import { TapResponseFrame, TapRequestFrame } from '@iotize/tap/client/api';
import {
  HostProtocol,
  TargetProtocol,
  VariableFormat,
  AppPathType,
  SpecialFeature,
  TapVersion,
} from '@iotize/tap';

/* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export enum AvailablePowerSource {
  DC_POWER = 1,
  S3P = 16,
  AC_EXTERNAL_POWER = 32,
}
